<template>
  <div class="lab-settings">
    <b-container fluid>
      <b-row>

        <!-- LEFT TAB LIST -->
        <b-col md="2" class="pr-0">
          <b-list-group>
            <b-list-group-item
              v-for="(tab, index) in labSettingTabs"
              :key="index"
              :active="currentTab === index"
              @click="loadTab(tab, index)"
            >
              {{ index + 1 }}) {{ tab.name }}
            </b-list-group-item>
          </b-list-group>
        </b-col>

        <!-- RIGHT CONTENT -->
        <b-col md="10" class="pl-0">
          <component
            v-if="currentComponent"
            :is="currentComponent"
            :course_id="course_id"
            :roles="selectedTab.roles || []"
            :methodId="selectedTab.methodId || null"
            @methods-updated="fetchSeminarMethods"
          />
        </b-col>

      </b-row>
    </b-container>
  </div>
</template>

<script>
import SeminarMethodsAndParameters from "./SeminarMethodsAndParameters.vue";
import SeminarTypeTab from "./SeminarTypeTab.vue";
import axios from "axios";

export default {
  name: "SeminarDashboardNew",

  props: {
    course_id: {
      type: [Number, String],
      required: true
    },
    role_by: {
      type: String
    },
    roles: {
      type: Array,
      default: () => []
    }
  },

  components: {
    SeminarMethodsAndParameters,
    SeminarTypeTab
  },

  data() {
    return {
      currentTab: 0,
      currentComponent: null,
      evaluationMethods: [],
      selectedTab: null
    };
  },

  created() {
    this.fetchSeminarMethods();
  },

  computed: {
    defaultInstitutionUserId() {
      return this.$store.getters.getDefaultInstituteUserId;
    },

    labSettingTabs() {
      const tabs = [];

      if (this.roles.includes('instructor') || (this.role_by !== "seminarFaculty" && this.role_by !== "projectFaculty")) {
        tabs.push({
          name: "Evaluation Types & Parameters",
          component: "SeminarMethodsAndParameters"
        });
      }

      this.evaluationMethods.forEach(method => {
        const accessibleRoles = (method.roles || []).filter(role =>
          (role.faculties || []).some(
            faculty => faculty.id === this.defaultInstitutionUserId
          )
        );

        if (accessibleRoles.length > 0) {
          tabs.push({
            name: method.name,
            component: "SeminarTypeTab",
            roles: accessibleRoles,
            methodId: method.id
          });
        }
      });

      return tabs;
    }
  },

  watch: {
    labSettingTabs: {
      immediate: true,
      handler(tabs) {
        if (!tabs.length) return;

        if (!this.currentComponent) {
          this.currentTab = 0;
          this.currentComponent = tabs[0].component;
          this.selectedTab = tabs[0];
        }
      }
    }
  },

  methods: {
    loadTab(tab, index) {
      if (
        !this.roles.includes('instructor') &&
        tab.component === "SeminarMethodsAndParameters"
      ) {
        return;
      }

      this.currentTab = index;
      this.currentComponent = tab.component;
      this.selectedTab = tab;
    },

    async fetchSeminarMethods() {
      const url = `${this.$store.getters.getAPIKey.mainAPI}/seminarmethods?course_id=${this.course_id}`;

      try {
        const response = await axios.get(url);

        this.evaluationMethods = response.data.map(method => ({
          id: method.id,
          name: method.name,
          roles: method.roles || [],
          parameters: method.seminar_parameters ?? []
        }));

        this.currentComponent = null;
        this.selectedTab = null;
        this.currentTab = 0;
      } catch (error) {
        this.$toast.error("Failed to fetch evaluation methods", {
          position: "top",
          duration: 3000
        });
      }
    }
  }
};
</script>
